export default __webpack_public_path__ + "static/media/05_photo.ba1e5a4d.jpg";